import { JSConn } from "@/utilities/js-conn";

export default {
  name: "templateWorkOrderLots",
  data() {
    return {};
  },
  computed: {
    templateWorkOrderLots: function() {
      return this.$store.getters.templateWorkOrderLots;
    },
    templateWorkOrder: function() {
      return this.$store.getters.templateWorkOrder;
    },
  },
  methods: {
    deleteLot(lot) {
      const jsConn = new JSConn();
      jsConn.formParams = lot;
      this.$store.dispatch("deleteTemplateWorkOrderLot", jsConn).then(() => {
        this.$emit("templateLotsChanged");
      });
    },
  },
};
